import { useDispatch, useSelector } from "react-redux";
import { closeError } from "../../../../store/reducer/_uiReducer";
import { getErrors } from "../../../../store/selectors";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import { useCallback } from "react";
import "./index.scss";

const ErrorContainer = () => {
  const dispatch = useDispatch();
  const errors = useSelector(getErrors);

  const handleClose = useCallback(
    (id) => {
      id && dispatch(closeError(id));
    },
    [dispatch],
  );

  const renderErrors = useCallback(() => {
    return errors.map(
      ({
        autohide = true,
        dismissed = false,
        duration = 2000,
        id = null,
        message = null,
        title = null,
        variant = "light",
      }) => (
        <Toast
          key={id}
          onClose={() => handleClose(id)}
          show={!dismissed}
          delay={duration || 2000}
          autohide={autohide}
          bg={variant}
        >
          {title && (
            <Toast.Header className="justify-content-between">
              {title}
            </Toast.Header>
          )}
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      ),
    );
  }, [errors, handleClose]);

  return (
    <ToastContainer position="top-center" className="p-3 error-toast-container">
      {renderErrors()}
    </ToastContainer>
  );
};

export default ErrorContainer;
